import { frontendURL } from '../../../../helper/URLHelper';
import {
  ROLES,
  CONVERSATION_PERMISSIONS,
} from 'dashboard/constants/permissions.js';
import SettingsWrapper from '../SettingsWrapper.vue';
import EmailAntispamHome from './Index.vue';

export default {
  routes: [
    {
      path: frontendURL('accounts/:accountId/settings/email-antispam'),
      component: SettingsWrapper,
      children: [
        {
          path: '',
          redirect: to => ({ name: 'email_antispam_list', params: to.params }),
        },
        {
          path: 'list',
          name: 'email_antispam_list',
          meta: {
            permissions: [...ROLES, ...CONVERSATION_PERMISSIONS],
          },
          component: EmailAntispamHome,
        },
      ],
    },
  ],
};
